import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const COO_KEEP_ON_TRACK_TASK: BuiltInTaskDefinition = {
    slug: 'coo-keep-on-track',
    name: 'Keep the enterprise on track',
    kind: 'llm',
    overlapPolicy: 'os',
    concurrencySafe: false,
    serializeOn: null,
    builtInRole: 'recovery',
    chatPurpose: null,
    goal: 'Nothing sits stuck on Blockers waiting for someone to open the page: each tick retries what a fresh run gets past, clears the leftovers of cancelled waits, and hands the rest to the lead of the team whose work is stuck',
    metric: {
        text: 'Share of runs on Blockers that a tick retried, cleared or escalated to their lead within fifteen minutes of stopping',
    },
    guardrails: [
        'Only the runs os.list_blockers hands back, each by its runId; never a run you did not read from the tool',
        'One move per run per tick: leave it, clear it, retry it or escalate it, never two',
        'Skip every run that already has an escalation: its lead or the CEO owns it now',
        'Retry only a run whose taskRetries is 0 and whose failure a fresh run gets past; escalate a second failure',
        'Clear only the leftover of a cancelled wait (ceo_wait_run_cancelled), never a loop cap: you cannot read issues or pull requests, so a row that may be finished goes to its lead',
        'Never approve, reject or skip a gate: gates are not this task',
        'Name every run you moved in the final JSON, and say plainly when there was nothing to do',
    ],
    inputs: [],
    tools: ['os.list_blockers', 'os.retry_run', 'os.clear_run', 'os.escalate_run'],
    gates: [],
    spend: {
        moneyUsdPerRun: 1,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [
        {
            slug: 'task-self-improvement',
            on: 'terminal',
        },
    ],
    cadenceMinutes: 15,
    cadenceOnlyAfterActivity: true,
    skillMd: TASK_TEXT['coo-keep-on-track.md'],
    adapterMd: TASK_TEXT['coo-keep-on-track.adapter.md'],
}
